
import { cartManager } from "@/utilities";
import { ORDER_TYPE, OPTION_TYPE } from "@/utilities/enums"
import couponMixin from "./couponMixin";
import {
  canMakeOrder,
  checkforAutoCoupon,
  controlAvailibilityBeforeCheckout,
  showErrorMessageAlert,
  checkOrderItemsAvailibilityForToday,
  checkRequiredAllRequiredItems,
  getMinimumDeliveryPrice,
  getAllSelectedOrderItems,
  getDefaultDeliveryFee,
  getDeliveryFee,
  getAllSelectItems,
  checkIfTheItemHasSameOptions
} from "@/utilities/helper";
export default {
  name: "ordering mixin",
  mixins: [couponMixin],
  data() {
    return {
      isLoading: false,
      index: -1,
      
    };
  },
  computed: {
    locationStatus: function () {
      return canMakeOrder(this.selectedLocation, this.isMounted);
    },
  },
  methods: {
    async checkoutOrder(goTo = 'checkout') {
      this.isLoading = true;

      const refreshLocationResponse = await this.refreshLocationData().catch(error => { this.captureException(error) });

      if (!refreshLocationResponse) {
        showErrorMessageAlert(
          this.$t("generic_error.refresh_location_data"),
          null,
          "red",
          "OK"
        );
        this.isLoading = false;
        return false;
      }

      if (controlAvailibilityBeforeCheckout(this.locationStatus, this.newCart)) {
        let message = this.$t("message.location_temporary_closed");
        if (this.selectedLocation.openingHours.suspended) {
          message = this.$t("message.location_temporary_paused_to", {
            paused_to: this.selectedLocation.paused_to,
          });
        }

        showErrorMessageAlert(message, null, "red", "OK").then(() => {
          this.isLoading = false;
          this.goToHome();
        });
        return false;
      }

      //---- if the order is a Re-Order =>  check if the menuItem required options are selected
      const allItems = getAllSelectedOrderItems(this.newCart.order)

      const {menuItems,options, values } = await this.postCheckItemsAvailibilityRequest(allItems);
      
      if (menuItems?.length || options?.length || values?.length) {
        
        this.$root.$emit('forceRefreshMenuSection')

        let message = `${this.$t("message.items_not_available_for_now")} <br>`;
        if (menuItems?.length) {
          message += "<p>Menu Items : </p>";
          message += `<ul class='order-items'>`;
          menuItems.forEach((item) => {
            message += `<li>${item.name}</li>`;
          });
          message += "</ul>";
        }

        if (options?.length) {
          message += "<p>Options : </p>";
          message += `<ul class='order-items'>`;
          options.forEach((item) => {
            message += `<li>${item.name}</li>`;
          });
          message += "</ul>";
        }

        if (values?.length) {
          message += "<p>Choices : </p>";
          message += `<ul class='order-items'>`;
          values.forEach((item) => {
            message += `<li>${item.name}</li>`;
          });
          message += "</ul>";
        }

        showErrorMessageAlert(message,
          null,
          "red",
          this.$t("button.ok")
        );
        //-- Remove the Items
        this.removeItems({ menuItems: menuItems.map(x => x.id), options: options.map(x => x.id), values: values.map(x => x.id), deepRemove: true })
        this.isLoading = false;
        return;
      }

      const itemsAvailibilityForTodayResponse = await checkOrderItemsAvailibilityForToday(this.newCart.order, this.$moment(), this.locationMenuItems);

      if (
        itemsAvailibilityForTodayResponse.today.length ||
        itemsAvailibilityForTodayResponse.now.length
      ) {
        let message = "";
        if (itemsAvailibilityForTodayResponse.today.length) {
          message = `${this.$t(
            "message.items_not_available_for_today"
          )} : <br> <ul class='order-items'>`;
          itemsAvailibilityForTodayResponse.today.forEach((item) => {
            message += `<li>${item.name}</li>`;
          });
          message += "</ul>";
        }
        if (itemsAvailibilityForTodayResponse.now.length) {
          message += `${this.$t(
            "message.items_not_available_for_now"
          )} : <br> <ul class='order-items'>`;
          itemsAvailibilityForTodayResponse.now.forEach((item) => {
            message += `<li>${item.name}</li>`;
          });
          message += "</ul>";
        }

        message += `<p class='message'>${this.$t(
          "message.items_automaticaly_removed"
        )}</p>`;

        showErrorMessageAlert(
          message,
          "k-icon-preptime",
          this.staticColor.orange
        );

        //--- remove the outdated items
        let itemsId = itemsAvailibilityForTodayResponse.today
          .concat(itemsAvailibilityForTodayResponse.now)
          .map((x) => x.id);
        this.removeItems({ menuItems: itemsId })
        this.isLoading = false;
        return false;
      }

      const checkRequiredMenuItemOptionsResponse = await checkRequiredAllRequiredItems(this.newCart.order).catch(response => {

        showErrorMessageAlert(
          response,
          null,
          "red",
          this.$t("button.ok")
        );
      })

      if (!checkRequiredMenuItemOptionsResponse) {
        this.isLoading = false;
        return;
      }

      //--- verify the coupon if any is provided | coupon is only availabled for logged users
      if (this.user && this.newCart.coupon) {
        this.onSubmitCoupon(false, false).then((result) => {
          if (result) {
            this.continueWithCheckout(goTo);
          }
        });
      } else {
        this.continueWithCheckout(goTo);
      }
    },
    continueWithCheckout(goTo) {

      if (this.newCart.orderType != ORDER_TYPE.Delivery.id) {
        this.$router.push({ name: goTo });
        this.isLoading = false;
        return;
      }

      //--- if delivery is selected => check if the cart total price is greater then delivery minimum in the available delivery areas
      try {
        let min_total_price = getMinimumDeliveryPrice(
          this.selectedLocation.delivery_condition
        );

        if (this.newCart.total < min_total_price) {
          let message = this.$t("message.min_delivery_price", {
            color: this.staticColor.red,
            min_total_price: this.$options.filters.currency(min_total_price),
          });
          let options = {
            html: true,
            animation: "fade",
            type: "basic",
            backdropClose: false,
            customClass: "confirm",
          };
          this.$dialog.alert(message, options);
        } else {
          this.$router.push({ name: goTo });
        }
      } catch (e) {
        this.captureException(e);
        showErrorMessageAlert(
          this.$t("generic_error.check_deliver_fees"),
          null,
          "red",
          this.$t("button.ok")
        );
      }
      this.isLoading = false;
    },
    addItemToOrder(_currentItem, _openModal = false) {
      //---- if the location is closed and allow futur_accept_orders , popup is displayed
      const {
        can_accept_delivery,
        can_accept_collection,
        openingHours,
      } = this.locationStatus;

      if (
        (this.newCart.orderType == ORDER_TYPE.Delivery.id &&
          !this.locationStatus.can_accept_delivery) ||
        (this.newCart.orderType == ORDER_TYPE.Collection.id &&
          !this.locationStatus.can_accept_collection) ||
        (this.newCart.orderType == ORDER_TYPE.Table.id &&
          !this.locationStatus.can_accept_tableOrdering)
      ) {
        if (this.counterClick >= 4) {
          this.$notify({
            group: "bottomRight",
            title: this.$t('message.no_orders_title'),
            type: "warn",
            text: this.$t('message.location_not_taking_orders', { location_name: this.selectedLocation.name })
          });
        }
        this.counterClick++;
        return;
      }

      if (
        this.confirmedPopup === false &&
        ((this.newCart.orderType == ORDER_TYPE.Delivery.id &&
          !openingHours.delivery &&
          can_accept_delivery) ||
          (this.newCart.orderType == ORDER_TYPE.Collection.id &&
            !openingHours.collection &&
            can_accept_collection))
      ) {
        let message = this.$t('message.pre_order_confirmation', { location_name: this.selectedLocation.name })
        let options = {
          html: true, // set to true if your message contains HTML tags. eg: "Delete <b>Foo</b> ?"
          okText: this.$t('button.confirm'),
          cancelText: this.$t('button.no_thanks'),
          animation: "fade", // Available: "zoom", "bounce", "fade"
          type: "basic", // coming soon: 'soft', 'hard'
          verification: "continue", // for hard confirm, user will be prompted to type this to enable the proceed button
          //verificationHelp: 'Type "[+:verification]" below to confirm', // Verification help text. [+:verification] will be matched with 'options.verification' (i.e 'Type "continue" below to confirm')
          clicksCount: 1, // for soft confirm, user will be asked to click on "proceed" btn 3 times before actually proceeding
          backdropClose: false, // set to true to close the dialog when clicking outside of the dialog window, i.e. click landing on the mask
          customClass: "confirm", // Custom class to be injected into the parent node for the current dialog instance
        };

        this.$dialog
          .confirm(message, options)
          .then(() => {
            this.confirmedPopup = true;
            this.callbackAddItem(_currentItem, _openModal);
          })
          .catch(() => {
            this.continueProcessing = false;
          });
      } else {
        this.callbackAddItem(_currentItem, _openModal);
      }
      this.addEventListener();
    },
    callbackAddItem(_currentItem, _openModal) {

      if (_openModal) {
        if (!this.editMode) {
          this.fromItem = JSON.parse(JSON.stringify(_currentItem));
          if (this.fromItem.hasOptions) {
            this.fromItem.options.forEach((element) => {
              element.selected_items = []
              element.comment = "";
              if (element.type == "SELECT" || element.type == "RADIO") {
                element.selected = "";
              }
              else {
                element.selected = [];
              }
            });
          }
        } else {
          this.fromItem = JSON.parse(JSON.stringify(_currentItem));
        }
        //--- geive the Modal the Data and Open-it
        this.$refs.itemModal.openModal();
      } else {
        this.pushOrder(this.fromItem);
        
        this.applyCoupon();

        cartManager.setCart(this.newCart, true, true);

        this.$nextTick(() => {
          this.setCartDeliveryFee();
          this.$notify({
            group: "bottomRight",
            title: this.editMode ? this.$t('message.item_updated') : this.$t('message.item_added'),
            type: "success",
            text: this.editMode ? this.$t('message.item_updated_message', { item_name: _currentItem.name }) : this.$t('message.item_added_message', { item_name: _currentItem.name }),
          });
          //--- set Total
          this.$refs.itemModal.closeModal();
        });
      }
    },
    pushOrder(item) {
      //--- check if a coupon is not already applied => apply auto-coupon
      if (this.newCart.order.length <= 0) {
        this.newCart.order.push(item);
        return;
      }

      if (this.editMode && item.index >= 0) {
        this.$set(this.newCart.order, item.index, item)
        return;
      }

      let exist = false;

      for(let [index, orderItem] of this.newCart.order.entries()){

        if(orderItem.id != item.id) continue;

        //same item is already selected
        // if new item has different options selected , or has a different comment
        // we need to add-it as new entry to the order
        // if it's the same , we will update only the quantity
        if(checkIfTheItemHasSameOptions(item, orderItem)){
          orderItem.quantity = orderItem.quantity + item.quantity;
          this.$set(this.newCart.order, index, orderItem);
          exist = true;
          return;
        }

      }
      if (!exist) {
        this.newCart.order.push(item);
      }
    },
    removeItems(arrItems) {
      //---- get the card
      this.newCart.order = this.newCart.order.filter(x => !arrItems.menuItems.includes(x.id));

      if (arrItems.deepRemove) {
        //-- delete any section not available
        this.removeOrderSelectedItemsRecursively(this.newCart.order, arrItems)
      }

      this.$nextTick(() => {
        cartManager.setCart(this.newCart, true, true);
        this.setCartDeliveryFee();
      });

    },
    removeOrderSelectedItemsRecursively(orderItems, arrItemsDeleted) {
      orderItems.forEach(orderItem => {
        if (orderItem?.options?.length) {
          orderItem.options = this.removeOrderSelectedOptionsRecursively(orderItem.options, arrItemsDeleted)
        }

        if (orderItem?.sections?.length) {

          orderItem.sections = orderItem.sections.filter(x => !arrItemsDeleted.menuItems.includes(x.id));

          for (let section of orderItem.sections) {

            // check if any of the selected items 
            section.selected_items = section.selected_items.filter(t => !arrItemsDeleted.menuItems.includes(t.id));
            section.selected = section.type == OPTION_TYPE.checkbox ? section.selected_items.map(s => s.id) :
              section.selected_items.length ? section.selected_items[0].id : "";

            this.removeOrderSelectedItemsRecursively(section.subProducts.filter(p => section.selected_items.map(b => b.id).includes(p.id)), arrItemsDeleted)
          }
        }
      })

    },
    removeOrderSelectedOptionsRecursively(options, arrItemsDeleted, parentOption = null) {

      options = options.filter(x => !arrItemsDeleted.options.includes(x.id));

      for (let option of options) {

        option.selected_items = option.selected_items.filter(v => !arrItemsDeleted.values.includes(v.id));
        option.selected = option.type == OPTION_TYPE.checkbox ? option.selected_items.map(s => s.id) :
          option.selected_items.length ? option.selected_items[0].id : "";

        option.values = option.values.filter(v => !arrItemsDeleted.values.includes(v.id))

        if (parentOption) {
          let selectedValues = parentOption.values.filter(v => parentOption.selected_items.map(s => s.id).includes(v.id))

          for (let selectedValue of selectedValues) {

            if (!selectedValue?.options?.length) continue;

            for (let subOption of selectedValue.options) {
              let hasSelectedValue = false
              if (getAllSelectItems(subOption).length) {
                hasSelectedValue = true;
              }
              if (!hasSelectedValue) {
                parentOption.selected_items = parentOption.selected_items.filter(s => s.id != selectedValue.id);
                parentOption.selected = parentOption.type == OPTION_TYPE.checkbox ? parentOption.selected_items.map(s => s.id) :
                  parentOption.selected_items.length ? parentOption.selected_items[0].id : "";
              }

            }

            //if (!selectedValue?.options?.length) continue;

            /*parentOption.selected_items = parentOption.selected_items.filter(s => s.id != selectedValue.id);
            parentOption.selected = parentOption.type == OPTION_TYPE.checkbox ? parentOption.selected_items.map(s => s.id) :
              parentOption.selected_items.length ? parentOption.selected_items[0].id : "";*/
          }
        }

        let values = option.values.filter(p => option.selected_items.map(b => b.id).includes(p.id))
        for (let value of values) {
          if (!value.options.length) continue;
          value.options = this.removeOrderSelectedOptionsRecursively(value.options, arrItemsDeleted, option)
        }
      }

      return options;
    },
    removeItem(_index) {
      //---- get the card
      let itemToDelete = this.newCart.order[_index];
      this.$delete(this.newCart.order, _index);

      cartManager.setCart(this.newCart, true, true);
      this.$nextTick(() => {
        this.setCartDeliveryFee();
      });
      this.$notify({
        group: "bottomRight",
        title: this.$t('message.item_removed_notify_title'),
        type: "warn",
        text: this.$t('message.item_removed_from_order', { item_name: itemToDelete.name })
      });

      if (this.editMode) this.$refs.itemModal.closeModal();
      this.removeEventListner();
    },
    addEventListener() {
      this.$root.$off("PUSH_ITEM");
      this.$root.$on("PUSH_ITEM", (_object) => {
        this.editMode = _object.editMode;
        this.addItemToOrder(_object.item, _object.openModal);
      });
    },
    removeEventListner() {
      this.$root.$off("REMOVE_ITEM");
      this.$root.$on("REMOVE_ITEM", (_index) => {
        this.removeItem(_index);
      });
    },
    openPopUpConfirmationEventListner: function () {
      this.$root.$off("OPEN_POPUP_CONFIRMATION");
      this.$root.$on("OPEN_POPUP_CONFIRMATION", (data) => {
        this.$refs.popupConfirmation.ItemsNotAvailable = data.ItemsNotAvailable;
        this.$refs.popupConfirmation.ItemsWithDiffPrice =
          data.ItemsWithDiffPrice;
        this.$refs.popupConfirmation.shown = true;
        this.$refs.popupConfirmation.newOrderType = data.NewOrderType;
        this.$refs.popupConfirmation.oldOrderType = data.OldOrderType;
      });
    },
    applyCoupon() {
      if(!this.user) return;

      //no coupon applied until now
      
      if(this.newCart.coupon_result){
        this.onSubmitCoupon(false, false)
        return;
      }

      this.newCart.coupon = checkforAutoCoupon(this.selectedLocation)?.code;
      if (this.newCart.coupon) {
        this.onSubmitAutoCoupon();
      }

    },
    setCartDeliveryFee() {
      return new Promise((resolve) => {
        if (
          this.newCart.orderType == ORDER_TYPE.Delivery.id &&
          this.selectedLocation.delivery_condition &&
          this.selectedLocation.availabe_delivery_postcode
        ) {
          if (this.newCart.order.length)
            // call this method if the cart total is > to 0
            this.newCart.delivery_fee = getDeliveryFee(
              this.selectedLocation.delivery_condition,
              this.newCart.total
            );
          else {
            this.newCart.delivery_fee = getDefaultDeliveryFee(
              this.selectedLocation.delivery_condition
            );
          }
          cartManager.setCart(this.newCart, true, false);
          resolve(true);
        }
        resolve(false);
      });
    },

  },
};
